import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            {new Date().getFullYear()} © Farme.
                        </Col>
                        <Col sm={4}>
                            <div className="text-center d-none d-sm-block">
                                <Link 
                                    to="/changelog" 
                                    className="text-muted text-decoration-none"
                                    style={{ fontSize: '13px' }}
                                >
                                    <i className="ri-file-list-3-line me-1"></i>
                                    Registro de Cambios
                                </Link>
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className="text-sm-end d-none d-sm-block">
                                Design & Develop by Farme
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;